export const CreateDashboardSlotDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateDashboardSlot' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'AddSearchInsightsDashboardSlotsToDashboardInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addSearchInsightsDashboardSlotsToDashboard' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'dashboardId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'widgetId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'w' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'h' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
